import React from 'react';
import StatusFilter from 'src/app/admin/components/status-filter/StatusFilter';
import type { SiteStatus } from '../../state/api/organisationEngineSlice';

type SiteStatusFilterProps = {
    value: SiteStatus;
    onChange: (status: SiteStatus) => void;
};

const statuses: { value: SiteStatus; label: string }[] = [
    { value: 'active', label: 'Active' },
    { value: 'draft', label: 'Draft' },
    { value: 'archived', label: 'Archived' },
];

const SiteStatusFilter = ({ value, onChange }: SiteStatusFilterProps) => (
    <StatusFilter options={statuses} value={value} onChange={onChange} ariaLabel='Filter by site status' />
);

export default SiteStatusFilter;
